import {DatePipe} from '@angular/common'
import {Pipe, type PipeTransform, inject} from '@angular/core'
import {TranslateService} from '@ngx-translate/core'
import {InfoService} from '@services/info.service'

@Pipe({
  name: 'dateFormatPipe',
})
export class DateFormatPipe implements PipeTransform {
  readonly #translate = inject(TranslateService)
  readonly #infoService = inject(InfoService)

  transform(value: string, timezone?: string) {
    if (!value) {
      return ''
    }

    const date = this.parseUtcDate(value)
    const now = new Date()
    const diffDays = this.diffInDays(now, date)

    if (diffDays < 2) {
      return this.convertToNiceDate(date)
    }

    const format = this.#infoService.isIpadOrWebUser() ? 'dd/MM/yyyy' : 'dd/MM/yy'
    const datePipe = new DatePipe('en-US')
    return datePipe.transform(date, format, timezone)
  }

  convertToNiceDate(date: Date): string {
    const now = new Date()
    return this.myDateDiff(now, date)
  }

  myDateDiff(now: Date, date: Date): string {
    const diffSeconds = this.diffInSeconds(now, date)
    const diffDays = this.diffInDays(now, date)

    if (isNaN(diffDays) || diffDays < 0 || diffDays >= 31) {
      return ''
    }

    return (
      (diffDays === 0 &&
        ((diffSeconds < 60 && this.getStringDateFormattedDiff(date)) ||
          (diffSeconds < 120 && this.getStringDateFormattedDiff(date)) ||
          (diffSeconds < 3600 && this.getStringDateFormattedDiff(date)) ||
          (diffSeconds < 7200 && this.getStringDateFormattedDiff(date)) ||
          (diffSeconds < 86400 && this.getStringDateFormattedDiff(date)))) ||
      (diffDays === 1 && this.#translate.instant('yesterday'))
    )
  }

  private parseUtcDate(value: string): Date {
    const [datePart, timePart] = value.split(' ')
    const [month, day, year] = datePart.split(/[-/]/).map(Number)
    const [hours, minutes, seconds] = (timePart || '0:0:0').split(':').map(Number)
    return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds))
  }

  private diffInDays(from: Date, to: Date): number {
    return Math.floor((from.getTime() - to.getTime()) / (1000 * 60 * 60 * 24))
  }

  private diffInSeconds(from: Date, to: Date): number {
    return Math.floor((from.getTime() - to.getTime()) / 1000)
  }

  private getStringDateFormattedDiff(date: Date) {
    return `${date.getHours()}:${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`
  }
}
